import { ServerRepetitionPattern, IServerRepetitionPattern, isServerRepetitionPattern } from "./ServerRepetitionPattern";
import { IShift as DeprecatedIShift, Shift } from "../Shift";
import { IServerAddress, ServerAddress } from "./ServerAddress";
import { action, makeObservable, observable } from "mobx";
import { IShiftRegistration } from "../ShiftRegistration";
import { ShiftRegistration } from "..";
import { Archivable, IArchivable } from "../Archivable";
import { IInstanceData } from "../interfaces/IShift";
import { INotifiable } from "../interfaces/INotifiable";
import { InheritanceModes } from "../constants/InheritanceModes";

export const isServerShift = (x: any): x is IServerShift => {
    if (typeof x === 'object') {
        return isServerRepetitionPattern((x as { repetitionPattern: any }).repetitionPattern);
    } else {
        return false;
    }
}

export interface IServerShift extends IArchivable {
    id?: number;
    addressId?: number;
    address: IServerAddress | null;
    repetitionPattern: IServerRepetitionPattern;
    modifiedInstances?: IServerShift[];
    instanceData?: IInstanceData;
    slots: number;
    label: string;
    notes: string;
    highNeed: boolean;
    leadsMode: InheritanceModes;
    leads: INotifiable[];
    shiftRegistrations?: IShiftRegistration[];
}

export class ServerShift extends Archivable implements IServerShift {
    @observable id?: number;
    @observable addressId?: number;
    @observable address: ServerAddress | null;
    @observable repetitionPattern: ServerRepetitionPattern;
    @observable modifiedInstances?: ServerShift[];
    @observable instanceData?: IInstanceData;
    @observable slots: number;
    @observable label: string;
    @observable notes: string;
    @observable highNeed: boolean;
    @observable leadsMode: InheritanceModes;
    @observable leads: INotifiable[];
    @observable shiftRegistrations?: ShiftRegistration[];

    // private parentStartDate?: Date;

    constructor(clientOrServerObject: Shift | IServerShift) {
        super(clientOrServerObject);
        makeObservable(this);

        this.id = clientOrServerObject.id;
        this.repetitionPattern = new ServerRepetitionPattern(clientOrServerObject.repetitionPattern);
        if ('addressId' in clientOrServerObject && clientOrServerObject.addressId !== null && clientOrServerObject.addressId !== undefined) {
            this.addressId = clientOrServerObject.addressId;
        } else if ('address' in clientOrServerObject) {
            this.addressId = clientOrServerObject.address ? clientOrServerObject.address.id : undefined;
        }
        this.address = clientOrServerObject.address ? new ServerAddress(clientOrServerObject.address) : null;
        if (clientOrServerObject.modifiedInstances) {
            this.modifiedInstances = (clientOrServerObject.modifiedInstances as (Shift | IServerShift)[]).map(instance => new ServerShift(instance));
        }
        this.instanceData = clientOrServerObject.instanceData
            ? {
                defaultDaysFromStartDate: clientOrServerObject.instanceData.defaultDaysFromStartDate,
                deleted: clientOrServerObject.instanceData.deleted,
                parentId: clientOrServerObject.instanceData.parentId
            }
            : undefined;
        // The server should no longer be returning server-generated shift instances to the client (where timezoneOffsetApplied would equal false),
        // thus the following block of code and the functions it depends on are no longer needed.
        // if (clientOrServerObject.instanceData && 'parentStartDate' in clientOrServerObject.instanceData) {
        //     this.parentStartDate = clientOrServerObject.instanceData.parentStartDate
        //         ? new Date(clientOrServerObject.instanceData.parentStartDate)
        //         : undefined;
        //     // If the child instance's start and end times are based on a calculation from the 
        //     // parent instance, make any necessary adjustments based on differences in timezone
        //     // offset due to daylight saving time.
        //     if (clientOrServerObject.instanceData.timezoneOffsetApplied === false) {
        //         this.accountForTimezoneOffset();
        //     }
        // }
        this.slots = clientOrServerObject.slots;
        this.label = clientOrServerObject.label;
        this.notes = clientOrServerObject.notes;
        this.highNeed = clientOrServerObject.highNeed;
        this.leadsMode = clientOrServerObject.leadsMode;
        this.leads = clientOrServerObject.leads;

        this.shiftRegistrations = clientOrServerObject.shiftRegistrations
            ? (clientOrServerObject.shiftRegistrations as (IShiftRegistration | ShiftRegistration)[]).map(registration => new ShiftRegistration(registration))
            : undefined;
    }

    @action setAddress(address: ServerAddress) {
        this.address = address;
    }

    // @computed private get timezoneOffset() {
    //     return this.repetitionPattern.startTimestamp.getTimezoneOffset();
    // }

    // @computed private get parentTimezoneOffset() {
    //     return this.parentStartDate?.getTimezoneOffset();
    // }

    // private accountForTimezoneOffset() {
    //     // Compare the shift's timezone offset to the instance's timezone offset
    //     // Add hours or minutes as needed
    //     if (this.parentTimezoneOffset) {
    //         const differenceInTimezoneOffset = this.timezoneOffset - this.parentTimezoneOffset;
    //         if (differenceInTimezoneOffset !== 0) {
    //             const newStartTimestamp = addMinutes(this.repetitionPattern.startTimestamp, differenceInTimezoneOffset);
    //             const newEndTimestamp = addMinutes(this.repetitionPattern.endTimestamp, differenceInTimezoneOffset);
    //             this.repetitionPattern.setStartTimestamp(newStartTimestamp);
    //             this.repetitionPattern.setEndTimestamp(newEndTimestamp);
    //         }
    //     }
    // }

    // deserialize(): IShift {
    //     return {
    //         id: this.id || -1,
    //         slots: this.slots,
    //         address: this.address ? this.address.deserialize() : undefined,
    //         // addressId: this.addressId,
    //         repetitionPattern: this.repetitionPattern.deserialize(),
    //         modifiedInstances: (this.modifiedInstances || []).map(instance => instance.deserializeShiftInstance()),
    //         // instanceData: this.instanceData,
    //         shiftRegistrations: (this.shiftRegistrations || [])?.map(shiftRegistration => {
    //             const shiftIdentification = shiftRegistration.shiftIdentification;
    //             return {
    //                 registeringUserId: shiftRegistration.registeringUserId,
    //                 shiftIdentification: shiftIdentification.parentId
    //                     ? {
    //                         shiftId: shiftIdentification.shiftId,
    //                         parentId: shiftIdentification.parentId!,
    //                         defaultDaysFromStartDate: shiftIdentification.defaultDaysFromStartDate!
    //                     }
    //                     : { shiftId: shiftIdentification.shiftId! },
    //                 volunteerRegistrations: shiftRegistration.volunteerRegistrations,
    //                 registeredProxies: shiftRegistration.registeredProxies
    //             }
    //         }),
    //         archived: this.archived
    //     }
    // }

    // deserializeShiftInstance(): IShiftInstance {
    //     return {
    //         id: this.id || -1,
    //         slots: this.slots,
    //         address: this.address ? this.address.deserialize() : undefined,
    //         // addressId: this.addressId,
    //         repetitionPattern: this.repetitionPattern.deserialize(),
    //         // modifiedInstances: this.modifiedInstances?.map(instance => instance.deserialize()) as IShiftInstance[],
    //         instanceData: this.instanceData!,
    //         // shiftRegistrations: this.shiftRegistrations,
    //         // archived: this.archived
    //     }
    // }

    // TODO: Deprecate. Trying to use ITopLevelShift and IShiftInstance instead of IShift
    deprecatedDeserialize(): Shift {
        const shiftData: DeprecatedIShift = {
            id: this.id === undefined ? -1 : this.id,
            address: this.address ? this.address.deprecatedDeserialize() : undefined,
            addressId: this.addressId,
            repetitionPattern: this.repetitionPattern.deprecatedDeserialize(),
            modifiedInstances: this.modifiedInstances?.map(instance => instance.deprecatedDeserialize()),
            instanceData: this.instanceData,
            slots: this.slots,
            shiftRegistrations: this.shiftRegistrations,
            archived: this.archived,
            label: this.label,
            notes: this.notes,
            highNeed: this.highNeed,
            leadsMode: this.leadsMode,
            leads: this.leads
        }
        return new Shift(shiftData);
    }
}